/**
 * 워크숍 가격 표기.
 *
 * 화면마다 통화 표기가 달랐다 — 상세 페이지는 `55000.00$`, 장바구니는 `55,000won`.
 * KRW 워크숍(Prana Club 한옥 웰니스)이 상세 페이지에서 달러로 보이던 원인이 여기 있어
 * 통화를 받아 한 곳에서 포맷한다.
 *
 * - KRW → "55,000won" (장바구니·결제 요약과 같은 표기)
 * - USD(기본) → "15.00$" (기존 상세 페이지 표기 유지)
 */
export const toNumericPrice = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value === 'string') {
    const normalized = value
      .replace(/USD|KRW|usd|krw|won|원|\$|₩/g, '')
      .replace(/,/g, '')
      .trim();
    if (!normalized) return null;
    const parsed = Number.parseFloat(normalized);
    return Number.isNaN(parsed) ? null : parsed;
  }
  if (typeof value === 'object') {
    const candidates = [value.price, value.amount, value.value, value.cost];
    for (const candidate of candidates) {
      const numeric = toNumericPrice(candidate);
      if (numeric !== null) return numeric;
    }
  }
  return null;
};

export const formatWorkshopPrice = (price, currency = 'USD', isFree = false) => {
  if (isFree) return 'Free';
  const numeric = toNumericPrice(price);
  const cur = String(currency || 'USD').toUpperCase();
  if (numeric === null) return cur === 'KRW' ? '0won' : '0.00$';
  if (numeric <= 0) return 'Free';
  if (cur === 'KRW') return `${Math.round(numeric).toLocaleString('ko-KR')}won`;
  return `${numeric.toFixed(2)}$`;
};

/**
 * 메일·계좌 안내 표기: "KRW 55,000" / "USD 15.00" (통화 코드 앞).
 */
export const formatCurrencyAmount = (amount, currency = 'KRW') => {
  const numeric = toNumericPrice(amount);
  const cur = String(currency || 'KRW').toUpperCase();
  if (numeric === null) return `${cur} -`;
  if (cur === 'KRW') return `KRW ${Math.round(numeric).toLocaleString('en-US')}`;
  return `${cur} ${numeric.toFixed(2)}`;
};

export const isBankTransferMethod = (method) =>
  String(method || '').toUpperCase() === 'BANK_TRANSFER';
